import { type PropsWithChildren, zodResolver } from '@shared/utils';
import { createContext, useMemo, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import type { TaskManagementQuestionListType } from '../../components/task-management-question-list-data-grid';
import { QUESTION_REVIEW_TASK_CREATION_FORM_DEFAULT_VALUES } from '../../constants/form-defaults';

import {
  QuestionReviewTaskCreationFormSchema,
  type QuestionReviewTaskCreationFormInput,
} from './question-review-task-creation-form-schema';

export interface QuestionReviewTaskCreationSelectedRowsContextValue {
  selectedQuestionRows: TaskManagementQuestionListType[];
  setSelectedQuestionRows: (rows: TaskManagementQuestionListType[]) => void;
}

export const QuestionReviewTaskCreationSelectedRowsContext =
  createContext<QuestionReviewTaskCreationSelectedRowsContextValue | null>(null);

export default function QuestionReviewTaskCreationFormProvider(props: Readonly<PropsWithChildren>) {
  const { children } = props;
  const [selectedQuestionRows, setSelectedQuestionRows] = useState<
    TaskManagementQuestionListType[]
  >([]);

  const formContext = useForm<QuestionReviewTaskCreationFormInput>({
    defaultValues: QUESTION_REVIEW_TASK_CREATION_FORM_DEFAULT_VALUES,
    resolver: zodResolver(QuestionReviewTaskCreationFormSchema),
  });

  const selectedQuestionRowsContextValue = useMemo(
    () => ({
      selectedQuestionRows,
      setSelectedQuestionRows,
    }),
    [selectedQuestionRows],
  );

  return (
    <QuestionReviewTaskCreationSelectedRowsContext.Provider
      value={selectedQuestionRowsContextValue}
    >
      <FormProvider {...formContext}>{children}</FormProvider>
    </QuestionReviewTaskCreationSelectedRowsContext.Provider>
  );
}
